import React from 'react';
import { length, includes } from 'ramda';
import { isBlank } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import Loader from 'sharedComponents/Loader';
import InfiniteScroll from 'react-infinite-scroll-component';

import RealEstateAgentCard from './components/RealEstateAgentCard';
import useStyles from './useStyles';

const RealEstateAgentsList = props => {
  const {
    realEstateAgents,
    isLoading,
    onAddToWaitlist,
    meta,
    onLoadMore,
    inWaitlistRealEstateAgentsIds,
    inFavoritesRealEstateAgentsIds,
    isAddingToWaitlist,
    showActions,
  } = props;

  const classes = useStyles();
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className={classes.loaderBox}>
        <Loader />
      </div>
    );
  }

  if (isBlank(realEstateAgents)) {
    return (
      <div className={classes.container}>
        <Typography className={classes.emptyLabel} variant="subtitle1">
          {t('components.LoanOfficerRealEstateAgents.RealEstateAgentsList.emptyRealEstateAgents')}
        </Typography>
      </div>
    );
  }

  const { totalPages, currentPage, nextPage } = meta;
  const hasMore = currentPage < totalPages;

  const handleLoadMore = () => {
    onLoadMore({ page: nextPage });
  };

  return (
    <div className={classes.container} id="scrollableDiv" key="scrollableDiv">
      <InfiniteScroll
        dataLength={length(realEstateAgents)}
        next={handleLoadMore}
        hasMore={hasMore}
        loader={
          <div>
            {[1, 2, 3].map(key => (
              <div key={key} className={classes.skeletonBox}>
                <Skeleton variant="circle" animation="wave" width={40} height={40} />
                <Skeleton variant="rect" animation="wave" className={classes.skeletonText} />
              </div>
            ))}
          </div>
        }
        scrollableTarget="scrollableDiv"
      >
        {realEstateAgents.map(realEstateAgent => {
          const realEstateAgentId = realEstateAgent.id;
          const isInFavorites = includes(realEstateAgentId, inFavoritesRealEstateAgentsIds);
          const isInWaitlist = includes(realEstateAgentId, inWaitlistRealEstateAgentsIds);

          return (
            <RealEstateAgentCard
              key={realEstateAgentId}
              realEstateAgent={realEstateAgent}
              isInFavorites={isInFavorites}
              isInWaitlist={isInWaitlist}
              isAddingToWaitlist={isAddingToWaitlist}
              onAddToWaitlist={onAddToWaitlist(realEstateAgent)}
              showActions={showActions}
            />
          );
        })}
      </InfiniteScroll>
    </div>
  );
};

RealEstateAgentsList.propTypes = {
  realEstateAgents: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  onAddToWaitlist: PropTypes.func,
  inWaitlistRealEstateAgentsIds: PropTypes.arrayOf(PropTypes.number),
  inFavoritesRealEstateAgentsIds: PropTypes.arrayOf(PropTypes.number),
  isAddingToWaitlist: PropTypes.bool,
  showActions: PropTypes.bool,
};

RealEstateAgentsList.defaultProps = {
  onAddToWaitlist: () => {},
  inWaitlistRealEstateAgentsIds: [],
  inFavoritesRealEstateAgentsIds: [],
  isAddingToWaitlist: false,
  showActions: false,
};

export default RealEstateAgentsList;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerRealEstateAgents/components/RealEstateAgentsList/RealEstateAgentsList.js